/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import type { PracticeLocation } from "parog-web/cnam/types";
import type InsWithConfirmationRetrievalContext from "parog-web/contexts/ins-with-confirmation-retrieval-context";

interface Args {
  context: InsWithConfirmationRetrievalContext;
}

export default class InsRetrieveAccessFormSetPracticeLocationWithBillingNumberComponent extends Component<Args> {
  @tracked tempPracticeLocation?: string =
    this.args.context.authenticationContext
      .practiceLocationsWithValidBillingNumber![0].structureName;
  @tracked selectedPracticeLocationIndex = 0;

  get practiceLocationsWithValidBillingNumber(): PracticeLocation[] {
    return this.args.context.authenticationContext
      .practiceLocationsWithValidBillingNumber!;
  }

  @action
  selectPracticeLocation(newIndex: number): void {
    this.selectedPracticeLocationIndex = newIndex;
    this.tempPracticeLocation =
      this.practiceLocationsWithValidBillingNumber[newIndex].structureName;
  }

  @action
  onSubmit(event: Event): void {
    event.preventDefault();
    this.args.context.practiceLocation = this.tempPracticeLocation as string;
    this.tempPracticeLocation = undefined;
    this.args.context.transitionTo();
  }
}
